import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const JobRoutes: RouteObject = {
	path: "/jobs/*",
	children: [
		{
			path: "email/competency/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { CompetencyEmailJobs } = await import(
							"@/components/Jobs/CompetencyEmailJobs"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<CompetencyEmailJobs />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { CompetencyEmailJobs } = await import(
							"@/components/Jobs/CompetencyEmailJobs"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<CompetencyEmailJobs />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
			],
		},
	],
};
